import 'ant-design-vue/dist/antd.css';
import("./bootstrap");
import("./antd")
import("./scss/index.scss")
